import { Injectable, Type } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ComponentHelperService {
  static getWidgetName(component: Type<any>): string {
    return ComponentHelperService.getName(component);
  }

  static getDynamicWidgetName(component: Type<any>): string {
    return ComponentHelperService.getName(component);
  }

  static getServiceName<T>(service: T): string {
    return this.getName(service, 'serviceName');
  }

  private static getName(component, fieldName = 'componentName'): string {
    if (component) {
      const name = (component as any)[fieldName] ?? component.prototype[fieldName];
      if (name) {
        return name;
      }
    }
    return null;
  }
}
